export const dayOfWeek = ["日", "月", "火", "水", "木", "金", "土"];

//コンストラクタでUTCにしてtoUnixで日本時間にしている。
//get,setともにUTCがつく関数を使う。
export default class Time {
  static readonly TimeDifference = 9 * 60 * 60 * 1000;
  static readonly ADay = 24 * 60 * 60 * 1000;
  static readonly AnHour = 60 * 60 * 1000;
  static readonly AMinute = 60 * 1000;
  static readonly ASecond = 1000;
  private readonly correctedUnix;

  constructor(unixTime: number) {
    this.correctedUnix = unixTime + Time.TimeDifference;
  }

  public static readonly Now = () => {
    return new Time(new Date().getTime());
  };

  readonly getTime = () => {
    return this.correctedUnix - Time.TimeDifference;
  };

  readonly getTimeFromStartOfDay = () => {
    return this.getTime() - this.Today();
  };

  static readonly toUnix = (date: Date) => {
    return date.getTime() - Time.TimeDifference;
  };

  readonly Today = () => {
    const date = new Date(this.correctedUnix);
    date.setUTCHours(0, 0, 0, 0);
    return Time.toUnix(date);
  };

  readonly GetDatesOfMonth = () => {
    const date = new Date(this.correctedUnix);
    date.setUTCHours(0, 0, 0, 0);
    date.setUTCMonth(date.getUTCMonth(), 1);
    const start = Time.toUnix(date);
    date.setUTCMonth(date.getUTCMonth() + 1);
    const end = Time.toUnix(date);

    const result: number[] = [];
    for (let pushing = start; pushing < end; pushing += Time.ADay) {
      result.push(pushing);
    }
    return result;
  };

  readonly DateStrings = () => {
    const date = new Date(this.correctedUnix);
    return {
      year: date.getUTCFullYear().toString(),
      month: (date.getUTCMonth() + 1).toString(),
      date: date.getUTCDate().toString(),
      hour: date.getUTCHours().toString(),
      minute: ("0" + date.getUTCMinutes()).slice(-2),
      second: date.getUTCSeconds().toString(),
      day: dayOfWeek[date.getUTCDay()],
    };
  };
}
